const n=(o,t)=>{const A=[];for(let r=0;r<o;r++)A.push(t(r));return A};module.exports=n;
